class FileService {
  formatFileSize(bytes: number | undefined | null): string {
    if (typeof bytes !== 'number') {
        return '0';
    }
    
    if (bytes >= (1024 * 1024 * 1024)) {
        return (bytes / (1024 * 1024 * 1024)).toFixed(2) + ' GB';
    }
    
    if (bytes >= (1024 * 1024)) {
        return (bytes / (1024 * 1024)).toFixed(2) + ' MB';
    }
    
    return (bytes / 1024).toFixed(2) + ' KB';
  }

  getExtension(fileName: string): string {
    return fileName.split('.').pop() || '';
  }
}

export const fileService = new FileService();